import styled from 'astroturf/react';
import Button from 'src/components/Button';
import Checkbox from 'src/components/Checkbox';
import Svg from 'src/components/Svg';
import TextField from 'src/components/TextField';

const Wrapper = styled('div')`
  position: relative;
`;

const Left = styled('div')`
  padding: 20px 0px 0px 0px;
  margin-right: 50px;
  background-color: var(--white);
  border-right: 1px solid var(--ph-gray-50);
  height: 100%;
  width: calc(100% - 50px);
  transition: width 0.3s;
  transition-delay: 0.05s;

  &.isFullSize {
    width: 100%;
  }

  &.isInfoExpanded {
    width: 60%;
    background-image:
      linear-gradient(
        to right,
        rgba(0, 0, 0, 0) 0%,
        rgba(var(--ph-gray-500-rgb), 0.1) 100%
      );
    background-position: 100%;
    background-repeat: no-repeat;
    background-size: 20px;
    display: inline-block;
    vertical-align: top;
    margin-right: 0;
    &.implementNewSaq{
      width: 70%;
    }
  }

  &.isInfoExpandedForExternal {
    width: 60%;
    background-image:
      linear-gradient(
        to right,
        rgba(0, 0, 0, 0) 0%,
        rgba(var(--ph-gray-500-rgb), 0.1) 100%
      );
    background-position: 100%;
    background-repeat: no-repeat;
    background-size: 20px;
    display: inline-block;
    vertical-align: top;
    margin-right: 0;
  }

  @media (max-width: 1450px) {
    &.isInfoExpanded.isSidebarExpanded {
      width: calc(100% - 500px);
    }

    &.isInfoExpandedForExternal.isSidebarExpanded {
      width: calc(100% - 500px);
    }
  }

  @media (max-width: 1300px) {
    &.isInfoExpanded {
      width: calc(100% - 500px);

      &.isSidebarExpanded {
        width: calc(100% - 430px);
      }
    }

    &.isInfoExpandedForExternal {
      width: calc(100% - 500px);

      &.isSidebarExpanded {
        width: calc(100% - 430px);
      }
    }
  }
`;

const Right = styled('div')`
  position: absolute;
  right: 0;
  top: 0;
  bottom: 0;
  width: 50px;
  padding: 25px 10px 10px 12px;
  background-color: rgba(var(--ph-gray-rgb-50), 0.2);
`;

const Title = styled('h1')`
  font-size: var(--ph-heading-five);
  font-weight: 400;
  font-stretch: normal;
  font-style: normal;
  letter-spacing: normal;
  color: var(--black);
  margin-top: 0;
  margin-bottom: 0;
  display: flex;
  flex-direction: row;
  padding-left: 5px;

  & > div:first-child {
    flex: 1;
  }
`;

const MenuWrapper = styled('div')`
  margin: 5px 0 10px 0;
`;

const MenuLink = styled('span')`
  font-size: var(--ph-text-sm);
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  color: var(--ph-gray-500);
  cursor: pointer;
  margin: 0 10px;
  position: relative;

  &::before {
    content: '';
    display: block;
    position: absolute;
    top: -5px;
    bottom: -5px;
    right: -10px;
    border-right: solid 1px rgba(var(--ph-gray-rgb-500), 0.2);
  }

  &:last-child::before {
    display: none;
  }

  &:first-child {
    margin-left: 0;
  }

  &.withIcon {
    margin-right: 30px;

    &::before {
      right: -25px;
    }
  }
`;

const QuickJumpIcon = styled(Svg)`
  width: 15px;
  position: absolute;
  right: -18px;
  top: -1px;
  fill: var(--ph-gray-500);
`;

const SectionWrapper = styled('div')`
  position: relative;

  &.root + &.root {
    margin-top: 30px;
  }

  &.collapsed + & {
    margin-top: 0 !important;
  }

  &.root > div[class*='SectionTitle'] {
    font-size: var(--ph-text-sm);
    margin-bottom: 15px;
    border-radius: var(--ph-border-radius-sm);
  }
  
  &.fromJob {
    &.root > div[class*='SectionTitle'] {
      border-radius: 0px;
    }
  }
`;

const SectionTitle = styled('div')`
  background-color: var(--ph-gray-500);
  display: flex;
  font-size: var(--ph-text-sm);
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: var(--white);
  margin-bottom: 15px;
  cursor: pointer;

  &.fromJob {
    color: var(--dark-blue);
    border-radius: 0px;
  }

  &[class*='level-1'] {
    background-color: var(--ph-light-cyan-50);
    &:hover {
      background-color:var(--ph-light-cyan-100);
    }
  }

  &[class*='level-2']  {
    background-color: var(--ph-light-cyan-25);
    &:hover {
      background-color: var(--ph-light-cyan-30);
    }
  }

  &[class*='level-3']  {
    background-color: var(--ph-lavender-gray-100);
    &:hover {
      background-color: var(--ph-lavender-gray-50);
    }
  }

`;

const SectionNumber = styled('div')`
  flex: 0 0 30px;
  padding: 10px;

  &.fromJob {
    font-family: var(--ph-font-family-lato-bold);
  }
`;

const SectionLabel = styled('div')`
  flex: 1;
  padding: 10px;
  position: relative;
  overflow: hidden;
  text-overflow: ellipsis;
  padding-right: 30px;

  &.fromJob {
    font-family: var(--ph-font-family-lato-bold);
  }
`;

const SectionToggleBtn = styled(Svg)`
  width: 15px;
  fill: var(--white);
  position: absolute;
  right: 10px;
  top: 10px;

  &.collapsed {
    transform: rotate(-90deg);
  }

  &.fromJob {
    fill: var(--dark-blue);
  }
`;

const QuestionWrapper = styled('div')`
  pointer-events: auto !important ;
  display: flex;
  flex-wrap: wrap;
  position: relative;
  margin-bottom: 10px;

  label {
    display: flex;
    align-items: center;
    color: var(--ph-gray-500);
    margin-bottom: 0;
    margin-top: 0;
  }

  &.isRectifiedQuestion {
    margin-top: 15px;
  }

  &.isFromCustomPanel {
    margin-top: 15px;
  }

  &.textFullSize {
    flex-wrap: wrap;

    label[class*='TextField'] {
      margin-left: -1px;
      margin-right: -2px;
      width: calc(100% + 2px);
    }
  }

  &.selected {
    cursor: default;
  }

  &.error {
    border-radius: 1px;
    border: solid 2px var(--red) !important;
    margin: -2px -1px -1px;
  }

  div[class*='datePickerFieldWrapper'],
  div[class*='SelectBoxContainer'],
  input[class*='NumberField'],
  input[class*='TextField'],
  textarea[class*='TextField'] {
    margin: 0 10px 0 0 !important;
  }

  label[class*='DatePickerField'] {
    width: calc(100% + 2px);
  }

  span[class*='checkbox__label'] {
    font-size: var(--ph-required-indicate) !important;
    color: var(--dark-blue);
    font-family: var(--ph-font-family-source-sans-pro-regular);
  }

  [class*= 'eiqInput'] {
    margin-bottom:0 !important;
  }

  div[class*='form-wrapper'] {
    margin-bottom: 0;
    input, textarea {
      font-size: var(--ph-required-indicate) !important;
      color: var(--dark-blue);
      font-family: var(--ph-font-family-source-sans-pro-regular);
      border: 0.5px solid var(--dark-gray) !important;
    }
  }
`;

const QuestionNumber = styled('div')`
  flex: 0 0 60px;
  padding: 10px;
  font-size: var(--ph-text-sm);
  font-stretch: normal;
  font-style: normal;
  letter-spacing: normal;
  color: var(--black);
`;

const QuestionLabel = styled('div')`
  flex: 0 0 100%;
  position: relative;
  font-size: var(--ph-text-sm);
  font-stretch: normal;
  font-style: normal;
  letter-spacing: normal;
  color: var(--ph-gray-500);
  margin-right: 15px;

  &.fullsize {
    flex: 1;
    background-color: var(--white);
  }

  &.onOwnLine {
    flex: 100%;
    border: 0 !important;
  }
`;

const QuestionResultLabel = styled('div')`
  margin: 10px 0;
  font-size: var(--ph-text-sm);
  font-stretch: normal;
  font-style: normal;
  letter-spacing: normal;
`;

const QuestionResultCompliant = styled('div')`
  color: var(--ph-green-500);
  fill: var(--ph-green-500);
`;

const QuestionResultNonCompliant = styled('div')`
  color: var(--ph-red-500);
  fill: var(--ph-red-500);
`;

const QuestionResultNA = styled('div')`
  color: var(--ph-gray-500);
  fill: var(--ph-gray-500);
`;

const QuestionResultIcon = styled(Svg)`
  width: 11px;
  margin-right: 5px;
`;

const QuestionTitle = styled('div')`
  font-size: var(--ph-text-sm);
  font-stretch: normal;
  font-style: normal;
  line-height: 2;
  letter-spacing: normal;
  color: var(--black);
`;

const QuestionText = styled('div')`
  font-size: var(--ph-heading-three);
  font-weight: 400;
  color: var(--black);
  padding: 0;
  margin-top: 10px;
`;

const QuestionTextWrapper = styled('div')`
  margin: 0 10px 0 0;

  [class*='eiqTextarea'] {
    margin-bottom: 0 !important;
  }

  [class*='eiqTextareaReadonly'], [class*='eiqInputReadonly'] {
    pointer-events: auto !important;
  }

  [class*='eiqInputReadonly'], [class*='eiqTextareaReadonly'] {
    overflow-y: auto;
    max-height: 100px;
    border: 1px solid var(--ph-gray-100);

    p {
      padding: 0 10px;
      min-height: 38px;
      line-height: 36.4px;
      font-size: 11px;
      margin-bottom: 0;
    }
  }
  
  [class*='has-error'] {
    p {
      text-align: left;
      span {
        font-size: var(--ph-required-indicate);
        color: var(--ph-red-500);
      }
    }
  }
`;

const QuestionNumberPercentTimeWrapper = styled('div')`
  margin: 0 10px 0 0;
  div[class* = 'percentage-input']{
    font-size: var(--ph-required-indicate);
    top: 15%;
  }
`;

const QuestionDescription = styled('div')`
  margin-top: 20px;
  font-size: var(--ph-text-sm);
  font-stretch: normal;
  font-style: normal;
  line-height: 1.5;
  letter-spacing: normal;
  color: var(--black);
  border-radius: var(--ph-border-radius-sm);
  background-color: #deebff;
  padding: 15px;
`;

const QuestionResultWrapper = styled('div')`
  margin: 25px 0;
  border: solid 1px var(--ph-gray-50);
  display: flex;

  div {
    flex: 1;
    border-right: solid 1px var(--ph-gray-50);
    line-height: 60px;
    text-align: center;
    position: relative;
    cursor: pointer;
    font-size: var(--ph-text-sm);
    font-stretch: normal;
    font-style: normal;
    letter-spacing: normal;
    color: var(--black);

    &:last-child {
      border-right: 0;
    }
  }
`;

const QuestionResultSelectCompliant = styled('div')`
  &.selected span {
    font-size: var(--ph-text-sm);
    font-stretch: normal;
    font-style: normal;
    line-height: 45px;
    letter-spacing: 0.2px;
    text-align: center;
    color: var(--white);
    display: block;
    position: absolute;
    left: 7px;
    right: 7px;
    top: 7px;
    bottom: 7px;
    border-radius: var(--ph-border-radius-sm);
    background-color: var(--ph-green-500);
  }
`;

const QuestionResultSelectNonCompliant = styled('div')`
  &.selected span {
    font-size: var(--ph-text-sm);
    font-stretch: normal;
    font-style: normal;
    line-height: 45px;
    letter-spacing: 0.2px;
    text-align: center;
    color: var(--white);
    display: block;
    position: absolute;
    left: 7px;
    right: 7px;
    top: 7px;
    bottom: 7px;
    border-radius: var(--ph-border-radius-sm);
    background-color: var(--ph-red-500);
  }
`;

const QuestionResultSelectNA = styled('div')`
  &.selected span {
    font-size: var(--ph-text-sm);
    font-stretch: normal;
    font-style: normal;
    line-height: 45px;
    letter-spacing: 0.2px;
    text-align: center;
    color: var(--white);
    display: block;
    position: absolute;
    left: 7px;
    right: 7px;
    top: 7px;
    bottom: 7px;
    border-radius: var(--ph-border-radius-sm);
    background-color: var(--ph-gray-500);
  }
`;

const AddNoteButtonWithTitleDiv = styled('div')`
  display: flex;
  width: 100%;
  white-space: nowrap;
  margin-bottom: 20px;
  align-items: center;
  justify-content: space-between;

  &.noFlex {
    display: block;
  }
`;

const AddButtonWrapper = styled('div')`
  cursor: pointer;
  margin-right: 25px;
`;

const AddButton = styled(Svg)`
  width: 22px;
  margin: 15px 0 0 0;

  circle {
    fill: var(--ph-light-blue-500);
  }
`;

const AddButtonLabel = styled('span')`
  position: relative;
  top: -5px;
  margin-left: 5px;
`;

const AlertNotification = styled('div')`
  margin-top: 15px;
  font-size: var(--ph-text-sm);
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: var(--alert-notification);
`;

const AlertNotificationIcon = styled(Svg)`
  width: 13px;
  margin-right: 5px;
`;

const SectionsWrapper = styled('div')`
  overflow-y: auto;
  overflow-x: hidden;
  padding: 0 5px 0 15px;
  margin-bottom: 30px;
  margin-left: -10px;

  &.readOnly *{
    color: var(--ph-gray-200);
    pointer-events: none;
    
    div[class*='react-select__input-container']{      
      display: none;
    }
  }
  &.fromJob {
    &.readOnly *{
      color: var(--dark-blue);
      pointer-events: none;
    }
  }
`;

const BlockLabel = styled('div')`
  margin-top: 50px;
  font-size: var(--ph-text-sm);
  font-stretch: normal;
  font-style: normal;
  line-height: 2.27;
  letter-spacing: normal;
  color: var(--black);
`;

const QuestionResultDetails = styled(Svg)`
  width: 13px;
  position: absolute;
  bottom: 10px;
  right: 10px;
  opacity: 0.3;

  &.red {
    width: 19px;
    opacity: 1;
    fill: var(--ph-red-500);
  }
`;

const BlockFollowUp = styled('div')`
  float: right;
  cursor: pointer;
  font-size: var(--ph-text-sm);
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: 0.5px;
  color: var(--ph-gray-500);
  margin-top: 15px;
`;

const TableColumns = styled('div')`
  display: flex;

  &.maximizeWidth {
    flex: 1;
  }
`;

const TableColumn = styled('div')`
  flex: 1;
  text-align: left;
  font-size: var(--ph-text-sm);
  font-stretch: normal;
  font-style: normal;
  line-height: 1.5;
  letter-spacing: normal;
  font-family: var(--ph-font-family-source-sans-pro);
  font-size: var(--ph-required-indicate);
  color: var(--dark-blue);

  & + & {
    border-left: 0;
  }

  &.isError{
    font-family: var(--ph-font-family-source-sans-pro-semibold);
    color: var(--ph-red-500);
  }
`;

const TableFieldsWrapper = styled('div')`
  position: relative;
  margin-right: 35px;

  &.flash {
    -webkit-animation: fadeinout 2s linear forwards;
    animation: fadeinout 2s linear forwards;

    @-webkit-keyframes fadeinout {
      50% { box-shadow: 0 0 0 2px var(--ph-green-900); }
    }

    @keyframes fadeinout {
      50% { box-shadow: 0 0 0 2px var(--ph-green-900); }
    }
  }

  &.error {
    box-shadow: 0 0 2px 2px var(--ph-red-500);
  }
`;

const TableFieldsAddButtonWrapper = styled('div')`
  width: fit-content;
  cursor: pointer;
`;

const TableFieldsAdd = styled(Svg)`
  width: 17px;
  cursor: pointer;
`;

const TableFieldsAddLabel = styled('span')`
  font-size: var(--dark-blue);
  margin-left: 10px;
  position: relative;
  top: -3px;
  font-family: var(--ph-font-family-source-sans-pro-semibold);
  cursor: pointer;
`;

const TableFieldsRemove = styled('span')`
    position: absolute;
    right: -25px;
    top: 3px;
    background-color: var(--dark-blue-10);
    padding: 15px;
    border-radius: 20px;
    z-index: 9;
    cursor: pointer;

    &:hover {
      background-color: var(--ph-box-shadow-error-10);

      &::before, 
      &::after {
        background-color: var(--ph-red-500);
      }
    }

    &::before,
    &::after {
      background-color: var(--dark-blue);
      content: " ";
      height: 15px;
      left: 14px;
      position: absolute;
      width: 1.5px;
      top: 8px;
    }

    &::before {
      transform: rotate(45deg);
    }
    &::after {
      transform: rotate(-45deg);
    }
`;

const TableFields = styled('div')`
  display: flex;
  position: relative;
  align-items: flex-start;
  margin-bottom: 15px;
  span[class*='JobDatasheetQuestionFixed'] {
    margin: 0px;
  }

  &:last-child {
    span[class*='JobDatasheetQuestionFixed'] {
      margin-bottom: 0;
    }
  }
`;

const TableField = styled('div')`
  flex: 1;
  min-height: 40px;
`;

const CurrencyWrapper = styled('div')`
  position: relative;
  width: 100%;
`;

const Currency = styled('div')`
  width: 30px;
  height: 30px;
  text-align: center;
  color: var(--dark-blue);
  font-size: var(--ph-required-indicate);
  cursor: pointer;
  display: inline-block;

  & + & {
    margin-left: 10px;
  }

  &.active {
    border: 1px solid var(--ph-gray-100);
    border-radius: 100%;
  }
`;

const CheckboxWrapper = styled(Checkbox)`
  padding-bottom: 20px;

  &.inTable {
    margin-top: 20px !important;
    margin-left: 10px !important;
  }

  &.error {
    box-shadow: 0 0 2px 2px var(--ph-red-500);
  }

  &.flash {
    -webkit-animation: fadeinout 2s linear forwards;
    animation: fadeinout 2s linear forwards;

    @-webkit-keyframes fadeinout {
      50% { box-shadow: 0 0 0 2px var(--ph-green-900); }
    }

    @keyframes fadeinout {
      50% { box-shadow: 0 0 0 2px var(--ph-green-900); }
    }
  }
`;
  
const AttachmentCheckboxWrapper = styled('input')`
  width: 15px;
  margin-right: 12px;
  height: 15px;
  position: relative;
  top: 1px;

  &.inTable {
    margin-top: 20px !important;
    margin-left: 10px !important;
  }

  &.error {
    box-shadow: 0 0 2px 2px var(--ph-red-500);
  }

  &.flash {
    -webkit-animation: fadeinout 2s linear forwards;
    animation: fadeinout 2s linear forwards;

    @-webkit-keyframes fadeinout {
      50% { box-shadow: 0 0 0 2px var(--ph-green-900); }
    }

    @keyframes fadeinout {
      50% { box-shadow: 0 0 0 2px var(--ph-green-900); }
    }
  }
  &:checked  {
    border-color: var(--ph-light-blue-500);
  }
`;

const AttachmentOptionContainer = styled('div')`
    display: flex;
    padding-top: 4px
`;

const FileWrapper = styled('div')`
  width: 100%;
  margin-right: 10px;
  margin-bottom: 10px;
  
  div[class*='filepond--root'] {
    margin-bottom: 0;
  }
  
  div[class*="filepond--wrapper"]{
    margin-right: 10px;
  }

  div[class*= "filepond--file"]{
    align-items:center;
    font-size: var(--ph-required-indicate);
    font-family: var(--ph-font-family-source-sans-pro);
  }

  a[class*= "filepond--credits"]{
    visibility: hidden;
  }

  div[class*="filepond--item-panel"] {
    background-color: var(--dark-blue) !important;
    border-radius: 0 !important;
  }

  li[class*="filepond--item"] {
    width: 100%;
    height:44px;
    margin-left : 0 !important;
    margin-right: 0 !important;
  }

  span[class*="filepond--file-info-sub"],
  span[class*="filepond--file-status-sub"] {
    display: none;
  }

  div[class*="filepond--drop-label"]{
    font-size: var(--ph-required-indicate);
    font-family: var(--ph-font-family-source-sans-pro);
    background: #0F12321A;
    height:90px;
  }

  div[class*="filepond--panel-root"] {
    background-color: transparent !important;
    border: 0 !important
  } 

  ul[class*="filepond--list"]{
    margin-top:10px;
    left:0;
    right:0;
  }

  &.downloadonly *{
    color: white !important;
    pointer-events: auto !important;

    span[class*="filepond--file-info-main"],
    span[class*="filepond--file-status"]
    {
    padding-bottom:5px;
    }
    div[class*="filepond--drop-label"] {
      display:none;
    }
  }
`;

const JobDatasheetQuestionFixed = styled('span')`
  margin: 0 10px 45px;
  line-height: 26px;
  display: block;
  font-size: var(--ph-required-indicate);
  color: var(--dark-blue);
`;

const CollapsedBtn = styled('div')`
  position: sticky;
  right: 0;
  cursor: pointer;
  user-select: none;
  white-space: nowrap;
  background-color: var(--grey-btn);
  border-radius: var(--ph-border-radius-sm);
  padding: 10px 3px 10px 5px;
  margin-top: 10px;
  writing-mode: vertical-lr;
  font-size: var(--ph-text-sm);
  font-stretch: normal;
  font-style: normal;
  letter-spacing: normal;
  color: #66605c;
  transform: rotate(180deg);

  &.first {
    top: 0;
  }

  &.second {
    top: 112px;
  }

  &.lang-cn {
    transform: rotate(0deg);
  }

  &.isDisabled {
    cursor: not-allowed;
  }
`;

const InfoOverlay = styled('div')`
  position: sticky;
  vertical-align: top;
  display: inline-block;
  top: -25px;
  width: 40%;
  min-width: 500px;
  min-height: 250px;
  background-color: var(--white);
  transition: right 0.3s, min-width 0.3s, padding 0.3s;
  z-index: 9998;

  &.reducedWidth {
    width: 30%;
  }

  &.hidden {
    right: -100%;
    visibility: hidden;
  }

  @media (max-width: 1300px) {
    &.isSidebarExpanded {
      min-width: 430px;
      width: 430px;
      padding: 20px 20px;
    }
  }
`;

const InfoOverlayContent = styled('div')`
  overflow-y: auto;
  max-height: 100vh;
  overflow-x: hidden;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  padding: 30px 40px;
`;

const CloseBtn = styled(Svg)`
  width: 15px;
  height: 15px;
  cursor: pointer;
  position: absolute;
  top: 48px;
  right: 40px;

  path {
    fill: var(--dark-grey);
  }
`;

const SwitchButtonsWrapper = styled('div')`
  margin: 10px 0;
`;

const GreySwitchButton = styled('span')`
  width: 67px;
  height: 26px;
  border-radius: var(--ph-border-radius-sm);
  background-color: #f2f2f2;
  color: #66605c;
  font-size: var(--ph-text-sm);
  padding: 2px 9px 2px 9px;
  margin: 5px;
  cursor: pointer;

  &.selected {
    background-color: var(--ph-gray-500);
    color: var(--white);
  }

  &.small {
    font-size: var(--ph-text-sm);
  }
`;

const RedDot = styled('div')`
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: var(--ph-red-500);
  position: absolute;
  left: -15px;
  top: 20px;

  &.hide {
    display: none;
  }

  &.middle {
    top: 62%;
  }

  &[type="checkbox"] {
    top: 25%;
  }

  &[type="table"] {
    top: 55%;
  }
`;

const PercentWrapper = styled('div')`
  position: relative;
  width: 100%;

  &.flash {
    -webkit-animation: fadeinout 2s linear forwards;
    animation: fadeinout 2s linear forwards;

    @-webkit-keyframes fadeinout {
      50% { box-shadow: 0 0 0 2px var(--ph-green-900); }
    }

    @keyframes fadeinout {
      50% { box-shadow: 0 0 0 2px var(--ph-green-900); }
    }
  }
`;

const PercentOverlay = styled('div')`
  position: absolute;
  left: -10px;
  top: 3px;
  right: 0;
  bottom: 0;
  z-index: 1;
  padding: 0 18px;
  pointer-events: none;
  opacity: 0.5;
`;

const AttachmentWrapper = styled(`div`) `
   &.audio {
    margin-left: 27px;
   }  
   img {
    margin-left: 2em;
    width: 326px;
    height: 275px;
    object-fit: contain;

    @media screen and (max-width: 900px) {
     height: auto;
    }
    @media screen and (max-width: 600px) {
      width: calc(100% - 30px);
     }
  }
`;

const ImageText = styled(`div`) `
  margin-bottom: 2em;
  width: 40%;
  display: inline-flex;
  align-items: flex-end;
  float: left;
  margin-right: 2em;

  label {
    font-weight: bold;
    font-size: 22px;
  }

  @media screen and (max-width: 1100px) {
    margin-right: 4em;
  }
`;

const AttachmentText = styled('div')`
  margin-bottom: 2em;
  width: 40%;
  display: inline-flex;
  align-items: flex-end;
  float: left;
  margin-right: 2em;

  label {
    font-weight: bold;
    font-size: 22px;
    margin-right: 20px;
  }

  audio {
    position: relative;
    top: 5px;
    
    @media screen and (max-width: 600px) {
      width: 100%;
    }
  }

  @media screen and (max-width: 1100px) {
    margin-right: 4em;
  }

  @media screen and (max-width: 900px) {
    width: 100%;
  }

  @media screen and (max-width: 500px) {
    display: block;
  }
`;

const PictureLabelText = styled(`label`)`
  font-size: 14px;
  padding-right: 12px;
  position: relative;
  top: 0;
`;

const AttachmentOptionWrapper = styled(`ul`)`
  list-style: none;
  position: relative;
  clear: left;
  padding-left: 0px;
  flex-direction: column;

  &.checkboxOption {
    padding-left: 0px;
  }

  [class="radioOption"] {
    padding-left: 28px;
  }
`;

const AttachmentWrapperText = styled(`li`)`
  display: flex;
  position: relative;
  padding-bottom: 10px;
  flex-direction: column;
`

const InfoIcon = styled(Svg)`
  width: 14px;
  display: inline-block;
  margin-left: 10px;
  position: relative;
  top: 2px;
`;

const InfoTooltip = styled('span')`
  position: relative;

  &::before {
    content: attr(data-text);
    white-space: pre-line;
    min-width: 250px;
    position: absolute;
    top: 50%;
    left: 15px;
    transform: translate(0, -50%);
    color: var(--black);
    background: var(--white);
    padding: 15px;
    text-align: left;
    border: 1px solid var(--ph-gray-50);
    border-radius: var(--ph-border-radius-sm);
    box-shadow: var(--ph-box-shadow-sm);
    z-index: 1;
  }

  &::after {
    content: "";
    width: 15px;
    height: 15px;
    position: absolute;
    top: 0;
    left: 7px;
    transform: rotate(135deg);
    background: var(--white);
    border-bottom: 1px solid var(--ph-gray-50);
    border-right: 1px solid var(--ph-gray-50);
    box-shadow: 2px 2px 4px 0 rgba(39, 39, 39, 0.15);
    z-index: 1;
  }
`;

const TextFieldWrapper = styled(TextField)`
  &.error {
    box-shadow: 0 0 2px 2px var(--ph-red-500);
  }
`;

const MobileDataNoticeWrapper = styled('div')`
  width: 100%;
  background: var(--ph-gray-50);
  border-color: var(--ph-gray-100);
  border-radius: 10px;
  border-style: dashed;
  border-width: 2px;
`;

const MobileDataNotice = styled('div')`
  font-size: var(--ph-text-xs);
  color: var(--white) !important;
  background: var(--black);
  border-radius: 8px;
  margin: 15px;
  padding: 10px;
  line-height: 1.5;
`;

const PopupWrapper = styled('div')`
  position: fixed;
  right: 80px;
  top: 180px;
  z-index: 99999;
  overflow: hidden;
  border-radius: 5px;
  box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.3);
  background-color: var(--white);
  padding: 35px 15px;
  width: 100px;
  height: 100px;
  max-height: 450px;
`;

const ResultFamilySection = styled('div')`
  width: 40%;
`;

const DownloadButton = styled(Button)`
  min-width: 0;
  font-size: var(--ph-text-sm);
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: 1;
  letter-spacing: 0.86px;
  color: var(--white);
  padding: 10px 15px;

  &.rounded {
    border-radius: var(--ph-border-radius-sm);
  }

  &.disabled {
    background-color: var(--ph-gray-50) !important;
    color: var(--ph-gray-300);
    cursor: not-allowed;
    pointer-events: none;

    &:focus {
      box-shadow: none !important;
    }
  }
`;


const Disclaimer = styled('div')`
  [class*='prefill-disclaimer']  {
    background-color: var(--ph-dark-blue-400);
    max-width: 85%; 
    width: 100%; 
    padding:  12px 27px;
    margin: 10px 0px;
    border-radius: 3px;
    margin-left: 5px;

    @media (max-width: 1250px) {
      max-width: 100%;
    }

    @media (max-width: 768px) {
      max-width: 100%; 
    }

    li {
      list-style: disc;
      padding-bottom: 10px;
      font-size: var(--ph-text-sm) !important;
      color: var(--white) !important;
    }
  }
`;

const QuestionTypeFormContainer = styled('div')`
  display: flex;
  width: 100%;
`;

const QuestionTypeFormContainerInner = styled('div').attrs(
  ({ hasAttachments, ...props }) => ({
    ...props,
    style: {
      width: hasAttachments ? 'calc(100% - 40px)' : '100%',
    },
  }))`
  display: block;
  &.isLoadingDatePicker {
      div[class*='datePickerFieldWrapper']{
        width: 25%;
        max-width: 360px;
      }
  }
`;

const QuestionDropdownWrapper = styled('div')`
  div[class*='react-select__option'] {
    display: block !important;
    font-family: var(--ph-font-family-source-sans-pro-regular) !important;
    font-size: var(--ph-required-indicate) !important;
  }
  label[class*='checkbox-wrapper']{
    height: 26px;
  }    
  div[class*='react-select__multi-value__label']{
    padding: 3px 3px 3px 6px !important; 
    line-height: 1.5;
  }
  div[class*='react-select__single-value']{
    padding-top: 3px;
    padding-bottom: 3px;
    min-width: 40px;
    text-align: center;
    line-height: 1.5;
  }
  div[class*='react-select__value-container'], div[class*='react-select__value-container--is-multi']{
    margin-top: 2px;
    margin-bottom: 2px;
  }
  div[class*='react-select__input-container']{ 
    input, textarea {      
      border: none !important;
    }
  }
  div[class*='react-select__option'] {
    padding-top: 3px !important;
    padding-bottom: 3px !important;
  }
  input[class*='checkbox__input'] {
      color: var(--white) !important;
  }
  div[class*='react-select__value-container']{
    font-family: var(--ph-font-family-source-sans-pro-regular) !important;
    font-size: var(--ph-required-indicate) !important;
  }
`;

const QuestionRadioButtonWrapper = styled('div')`
  [class*='checkbox-wrapper'] {
    display: flex !important;
  }
`;

const QuestionAttachmentCountContainer = styled('div')`
  flex: 1;
  position: absolute;
  top: 60%;
  right: 0.7em;

  & > div[class="attachment-counter"] {
    position: absolute;
    top: -1em;
    right: -1em;
    background-color: var(--black);
    color: var(--white) !important;
    border-radius: 50%;
    width: 1.5em;
    text-align: center;
  }
`;

const AttachmentsCountIcon = styled(Svg)`
  width: 1.5em;
`;

const LanguageSelectWrapper = styled('div')`
  flex: 0 0 250px;

  [class*='language-select-wrapper'] {
    width: 130px;
    [class*='react-select-container'] {
      [class*='chips-placeholder'] {
        font-family: var(--ph-font-family-lato-regular) !important;
        font-size: var(--ph-required-indicate);
      }
      [class*='react-select__control'] {
        border: 0.5px solid var(--ph-light-gray-25);
        min-height: 28px;
        height: 28px;
      }
  
      [class*='react-select__control--is-focused'] {
        box-shadow: none;
      }
  
      [class*='react-select__menu'] {
        border-top: 2px solid var(--cyan-green);
        top: 95%;
        [class*='react-select__option'] {
          font-family: var(--ph-font-family-lato-regular) !important;
          font-size: var(--ph-required-indicate);

          [class*='u-mr-10'] {
            margin-right: 14px !important;
          }
        }
      }
    }
  }
`;

const OptionDefinitionContainer = styled('div')`
  display: flex;
  flex-direction: column;
  line-height: 1.7rem;
  margin-top: 0.5rem;
  word-break: break-all;
`;

const QuestionLinkageStatusWrapper = styled('div')`
  display: flex;
  align-items: center;
`;

const QuestionTextLabel = styled('span')`
  white-space: pre-wrap;
  word-wrap: break-word;
  font-size: var(--ph-required-indicate);
  color: var(--dark-blue);
  font-family: var(--ph-font-family-source-sans-pro-semibold);
  
  &.isLanguageHighlighted {
    color: var(--ph-red-500);
  }

  &.isMandatory {
    color: var(--dark-blue);
    font-size: var(--ph-required-indicate);
    font-family: var(--ph-font-family-source-sans-pro-semibold);
    text-align: left;
    letter-spacing: 0px;
    opacity: 1;
    &::before {  
      width: 5px;
      margin-right:5px;
      content: ' ';
      display: inline-block;
      clip-path: circle(2px at center);
      background: var(--cyan-green) 0% 0% no-repeat padding-box;
      opacity: 1;
    }
  }
  &.isError {
    font-family: var(--ph-font-family-source-sans-pro-semibold);
    color: var(--ph-red-500);
  }
`;

const RadioGroup = styled('div')`
  position: relative;
  display: flex;
  width: 100%;
  min-height: 60px;

  & + & {
    border-top: 0;
  }
`;

const RadioGroupCircle = styled('div')`
  width: 16px;
  height: 16px;
  margin-right: 6px;
  border: 1px solid rgba(var(--ph-gray-rgb-500), 0.4);
  border-radius: 50%;
  background-color: var(--white);
`;

const RadioGroupInput = styled('input')`
  width: 15px;
  height: 15px;
  margin-right: 12px;
  position: relative;
  top: 3px; 

  &:checked + [class*='RadioGroupCircle'] {
    border: solid 5px var(--ph-light-blue-500);
    border-color: var(--ph-light-blue-500);
  }
`;

const AttachmentOptionText = styled('span')`
  font-size: var(--ph-text-sm);
  font-stretch: normal;
  font-style: normal;
  line-height: 1.54;
  letter-spacing: normal;
  color: var(--charcoal-grey);
  position: relative;
  top: 1.1px;
`;

const SmileyContainer = styled('div')`
  &.fromSurveyExecution {
    display: flex;
    align-items: center;
    
    @media screen and (max-width: 600px) {
      flex-wrap: wrap;
      justify-content: center;
    }
  }
`;

const SmileyWrapper = styled('span')`
  display:inline-table;
  width: 67px;
  height: 26px;
  font-size: var(--ph-text-sm);
  padding: 8px 9px 8px 9px;
  margin: 5px;
  cursor: pointer;

  @media screen and (max-width: 600px) {
    display:inline-table;
    width: 26px;
    height: 15px;
    font-size: var(--ph-text-sm);
    padding: 2px 2px 2px 2px;
    margin: 2px;
    cursor: pointer;
  }

  & > pre {
    white-space: pre-wrap;
    font-size: var(--ph-text-sm);
    font-stretch: normal;
    font-style: normal;
    line-height: 26px;
    letter-spacing: normal;
    color: var(--ph-gray-500);
    font-family: var(--ph-font-family);
    display: flex;
    align-items: center;
    justify-content: center;
  }

  &:hover{
    -webkit-filter: brightness(1.2) opacity(.9);
    -moz-filter: brightness(1.2) opacity(.9);
    filter: brightness(1.2) opacity(.9);
  }

  &.selected{
    -webkit-filter: none!important;
    -moz-filter: none!important;
    filter: none!important;
    background: #beeded;

    svg {
      box-shadow: rgb(240 162 162 / 19%) 0px 10px 20px, rgb(60 47 47 / 23%) 0px 6px 6px;
      border-radius: 50%;
      background: rgb(0 0 0 / 19%);
    }

    pre {
      color: var(--black);
      font-weight: bold;
    }
  }
`;

const SmileyIcon = styled(Svg)`
  width: 55px;
  margin: 0 10px;
  vertical-align: middle;

  @media screen and (max-width: 600px) {
    width: 40px;
    margin: 0 10px;
    vertical-align: middle;
  }
`;

const StarRow = styled('div')`
  padding-left: 20px;
  color: var(--ph-gray-500);
  font-size: var(--ph-text-xs);
`;

const StarWrapper = styled('div')`
  display: inline-flex;
  flex-direction: row;
  width: 67px;
  height: 26px;
  font-size: var(--ph-text-sm);
  padding: 2px 9px 2px 9px;
  margin: 5px;
  cursor: pointer;

  @media screen and (max-width: 600px) {
    display:inline-flex;
    flex-direction: row;
    width: 20px;
    font-size: var(--ph-text-sm);
    padding: 2px;
    margin: 2px;
    cursor: pointer;
  }

  &.selected{
    & > div > svg > path {
      fill: #ffc933;
    }
  }
`;

const StarIcon = styled(Svg)`
  width: 55px;
  margin-right: 10px;
  vertical-align: middle;
  
  @media screen and (max-width: 600px) {
    width: 20px;
    margin-right: 2px;
    vertical-align: middle;
  }
`;

const MultiRadioWrapperText = styled('li')`
  display: flex;
  padding-bottom: 10px;
`;

const MultiRadioOptionContainer = styled('div')`
  display: flex;
  padding-top: 4px;

  label {
      input {
      &:disabled {
        cursor: not-allowed;
        background-color: var(--ph-gray-100);
      }
    }
  }
`;

const MultiRadioCheckboxWrapper = styled('input')`
  width: 16px;
  margin-right: 10px;
  height: 16px;

  &.inTable {
    margin-top: 20px !important;
    margin-left: 10px !important;
  }

  &.error {
    box-shadow: 0 0 2px 2px var(--ph-red-500);
  }

  &.flash {
    -webkit-animation: fadeinout 2s linear forwards;
    animation: fadeinout 2s linear forwards;

    @-webkit-keyframes fadeinout {
      50% { box-shadow: 0 0 0 2px var(--ph-green-900); }
    }

    @keyframes fadeinout {
      50% { box-shadow: 0 0 0 2px var(--ph-green-900); }
    }
  }

  &:checked  {
    border-color: var(--ph-light-blue-500);
  }
`;

const MultiRadioOptionText = styled('span')`
  font-size: var(--ph-text-sm);
  font-stretch: normal;
  font-style: normal;
  letter-spacing: normal;
`;

const QuestionRowWrapper = styled('div')`
  margin-bottom: 5px;
  padding-left: 10px;
  padding-bottom: 2px;
  
  &[class*='prefilled'] {
    border: 2px solid var(--ph-yellow-200);
    border-radius: var(--ph-border-radius-sm);
  }

  &[class*='cursor-auto'] {
    cursor: auto;
  }
  
  &[class*='highlight-question'] {
    background-color: var(--cyan-green-20) !important;
  }

  &[class*='highlight-on-hover'] {
    &:hover {
      background-color: var(--ph-gray-50);
    }
  }
`;


const ErrorWrapper = styled('div')`
  display:flex;
  text-align: left;
  font-size: var(--ph-required-indicate);
  font-family: var(--ph-font-family-source-sans-pro);
  letter-spacing: 0px;
  color: var(--ph-red-500);
  opacity: 1;
  padding: 5px 5px 5px 0px;
` ;

const DescriptionAlias = styled('div')`
  font-size: var(--ph-required-indicate);
  font-family: var(--ph-font-family-source-sans-pro-italic);
  color: var(--ph-gray-450) !important;
  line-height: 15px;
  padding-bottom: 5px;
  white-space: pre-wrap;
  word-wrap: break-word;
`;

const IndicateRequired = styled('div')`
  font-size: var(--ph-required-indicate);
  font-family: var(--ph-font-family-source-sans-pro);
  letter-spacing: 0px;
  color: var(--dark-blue);
  opacity: 1;
  margin-bottom: 10px;
  margin-left: 5px;
  &:before {  
    margin-right:5px;
    width: 5px;
    height: 5px;
    content: ' ';
    display: inline-block;
    clip-path: circle(2px at center);
    background: var(--cyan-green) 0% 0% no-repeat padding-box;
    opacity: 1;
  }
`;

const ErrorNote = styled('div')`
  font-size: var(--ph-required-indicate);
  font-family: var(--ph-font-family-source-sans-pro-semibold);
  letter-spacing: 0px;
  color: var(--ph-red-500);
  opacity: 1;
  margin: 0 5px 20px 5px;
  border-bottom: 2px solid var(--ph-red-500);
`;


export default {
  AddButton,
  AddButtonLabel,
  AddButtonWrapper,
  AddNoteButtonWithTitleDiv,
  AlertNotification,
  AlertNotificationIcon,
  AttachmentsCountIcon,
  BlockFollowUp,
  BlockLabel,
  AttachmentOptionContainer,
  AttachmentOptionWrapper,
  AttachmentWrapperText,
  CheckboxWrapper,
  CloseBtn,
  CollapsedBtn,
  Currency,
  CurrencyWrapper,
  DownloadButton,
  Disclaimer,
  FileWrapper,
  GreySwitchButton,
  ImageText,
  AttachmentText,
  AttachmentWrapper,
  InfoIcon,
  InfoOverlay,
  InfoOverlayContent,
  InfoTooltip,
  JobDatasheetQuestionFixed,
  PictureLabelText,
  Left,
  MenuLink,
  MenuWrapper,
  MobileDataNotice,
  MobileDataNoticeWrapper,
  PercentOverlay,
  PercentWrapper,
  AttachmentCheckboxWrapper,
  PopupWrapper,
  QuestionAttachmentCountContainer,
  QuestionDescription,
  QuestionDropdownWrapper,
  QuestionLabel,
  QuestionNumber,
  QuestionResultCompliant,
  QuestionResultDetails,
  QuestionResultIcon,
  QuestionResultLabel,
  QuestionResultNA,
  QuestionResultNonCompliant,
  QuestionResultSelectCompliant,
  QuestionResultSelectNA,
  QuestionResultSelectNonCompliant,
  QuestionResultWrapper,
  QuestionText,
  QuestionTextWrapper,
  QuestionNumberPercentTimeWrapper,
  QuestionTitle,
  QuestionTypeFormContainer,
  QuestionTypeFormContainerInner,
  QuestionRadioButtonWrapper,
  QuestionRowWrapper,
  QuestionWrapper,
  QuickJumpIcon,
  RadioGroup,
  RadioGroupInput,
  AttachmentOptionText,
  RedDot,
  ResultFamilySection,
  Right,
  SectionLabel,
  SectionNumber,
  SectionTitle,
  SectionToggleBtn,
  SectionWrapper,
  SectionsWrapper,
  SwitchButtonsWrapper,
  TableColumn,
  TableColumns,
  TableField,
  TableFields,
  TableFieldsAddButtonWrapper,
  TableFieldsAdd,
  TableFieldsAddLabel,
  TableFieldsRemove,
  TableFieldsWrapper,
  TextFieldWrapper,
  Title,
  Wrapper,
  LanguageSelectWrapper,
  OptionDefinitionContainer,
  QuestionLinkageStatusWrapper,
  QuestionTextLabel,
  SmileyWrapper,
  SmileyIcon,
  StarRow,
  StarWrapper,
  StarIcon,
  SmileyContainer,
  MultiRadioWrapperText,
  MultiRadioOptionContainer,
  MultiRadioCheckboxWrapper,
  MultiRadioOptionText,
  DescriptionAlias,
  ErrorWrapper,
  IndicateRequired,
  ErrorNote
};
